export * from './extendable-media-recorder-wav-encoder-broker-definition';
//# sourceMappingURL=index.js.map